<script setup>
import { ref } from 'vue'
import { Carousel3d, Slide } from 'vue3-carousel-3d'
import 'vue3-carousel-3d/dist/index.css'
import AllGradesChips from '@/components/home/AllGradesChips.vue'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import PlyrJsVideoPlayer from '@/components/video/PlyrJsVideoPlayer.vue'
const videosRepo = RepositoryFactory.get('CourseVideos')
const randomVideos = ref('')
const DEFAULT_GRADE = 12
const isLoading = ref(false)
const getRandomVideos = async function (grade) {
  randomVideos.value = []
  isLoading.value = true
  try {
    const {
      data: { data }
    } = await videosRepo.getRandomVideos(grade)
    randomVideos.value = data
    isLoading.value = false
  } catch (e) {
    isLoading.value = false
    console.log('FETCH RANDOM VIDEOS ERROR:', e)
  }
}
const checkVideoType = (videoUrl) => {
  if (videoUrl) {
    if (videoUrl.endsWith('.m3u8')) {
      return 'm3u8'
    } else if (videoUrl.includes('wlproxy')) {
      return 'wlproxy'
    } else {
      // alert(videoUrl)
      return 'default'
    }
  }
  // alert(this.videoType)
}
getRandomVideos(DEFAULT_GRADE)
const RandomVideo = ref()
const previousSlide = ref(0)
const handleSlideChange = (currentSlide) => {
  RandomVideo.value[previousSlide.value].pause()
  RandomVideo.value[currentSlide].play()
  previousSlide.value = currentSlide
}
</script>

<template>
  <v-container fluid tag="section" class="cl__section__margin__bottom position-relative">
    <v-row class="mb-8">
      <v-col
        cols="12"
        class="d-flex flex-column justify-center align-center text-center"
      >
        <h1 class="font-weight-bold cl-section__title" :class="[!$vuetify.display.mdAndDown ? 'mb-10' : '']" style="color: rgba(104, 109, 122, 1)">
          <span class="text-dark">کلاس‌های آنلاین</span> کلاسینو رو از نزدیک ببین
        </h1>
        <p class="cl__section__subtitle">
          می‌خوای بدونی اساتید در کلاس‌های کلاسینو چطور مباحث سخت رو ساده توضیح میدن؟ دوست داری با روش تدریس اساتید ما آشنا بشی؟ با دیدن این ویدیوها می‌تونی مطمئن بشی که بهترین انتخاب رو برای موفقیت تحصیلیت انجام دادی.
        </p>
      </v-col>
    </v-row>
    <AllGradesChips @atChangeChip="getRandomVideos($event)"></AllGradesChips>
    <v-row class="slider" v-if="randomVideos.length > 0">
      <Carousel3d
        :controls-visible="false"
        dir="rtl"
        display="3"
        inverse-scaling="200"
        space="280"
        width="1100"
        height="620"
        border="0"
        perspective="0"
        @afterSlideChange="handleSlideChange"
        class="carousel-live-class-slider"
      >
        <Slide v-for="(video, i) in randomVideos" :key="'3d-carousal-' + i" :index="i">
          <div class="sample__video__container">
            <div class="video__detail d-flex justify-content-between rounded-xl">
              <div class="font-weight-bold text-right">{{ video.course_name }}</div>
            </div>
            <div @mousedown.stop @mouseup.stop>
              <PlyrJsVideoPlayer
                v-if="checkVideoType(video.hd_video_url)"
                :vod-link="video.hd_video_url"
                ref="RandomVideo"
                :keyRef="'plyr' + i"
              >
              </PlyrJsVideoPlayer>
            </div>
          </div>
        </Slide>
      </Carousel3d>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div
          class="d-flex justify-content-md-center align-items-center flex-wrap"
          :class="{ 'justify-content-start': $vuetify.display.mdAndDown }"
        >
          <h3>ویژگی‌های کلاس:</h3>
          <v-chip variant="tonal" class="m-2 rounded-lg font-weight-bold" color="primary" border
            >آنلاینه</v-chip
          >
          <v-chip variant="tonal" class="m-2 rounded-lg font-weight-bold" color="primary" border
            >رفع اشکال داره</v-chip
          >
          <v-chip variant="tonal" class="m-2 rounded-lg font-weight-bold" color="primary" border
            >پرسش و پاسخ داره
          </v-chip>
          <v-chip variant="tonal" class="m-2 rounded-lg font-weight-bold" color="primary" border
            >تکالیف پیگیری میشه
          </v-chip>
          <v-chip variant="tonal" class="m-2 rounded-lg font-weight-bold" color="primary" border
            >آزمون برگزار میشه و …
          </v-chip>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss">
.slider {
  .video-inner-plyr-hd {
    overflow: hidden;
    border-radius: 20px;
  }

  .sample__video__container {
    position: relative;

    .video__detail {
      position: absolute;
      z-index: 2;
      color: #fff;
      width: 100%;
      padding: 16px;
      font-size: 16px;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #000 100%);

      div {
        &:first-child {
          @include media-breakpoint-down(md) {
            font-size: 0.7rem;
          }
        }
      }

      .live__badge {
        .dots {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: rgba(240, 68, 56, 1);
        }

        color: rgba(240, 68, 56, 1);
      }

      @keyframes flickerAnimation {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      @-o-keyframes flickerAnimation {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      @-moz-keyframes flickerAnimation {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      @-webkit-keyframes flickerAnimation {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }

      .animate-flicker {
        -webkit-animation: flickerAnimation 1s infinite;
        -moz-animation: flickerAnimation 1s infinite;
        -o-animation: flickerAnimation 1s infinite;
        animation: flickerAnimation 1s infinite;
      }
    }
  }
}
</style>
